import { render, staticRenderFns } from "./wc-gates.vue?vue&type=template&id=d50c29de&"
import script from "./wc-gates.vue?vue&type=script&lang=js&"
export * from "./wc-gates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports